<template>
  <Layout footer>
    <div
      class="app-container n-config-provider app-container_warp"
      style="background-color: transparent"
      v-if="newsDetails.id"
    >
      <div class="newedit">
        <div class="online_right_title flex">
          <span class="mr-1" style="color: #333639; font-size: 18px">所在位置：</span>
          <NBreadcrumb>
            <NBreadcrumbItem style="color: #666" @click="gotoHome">首页</NBreadcrumbItem>
            <NBreadcrumbItem
              style="color: #666"
              @click="handleClickLevel(channelItem, 1)"
              v-if="channelItem.name && route.query.type != 1005"
            >
              {{ channelItem.name }}</NBreadcrumbItem
            >
            <NBreadcrumbItem style="color: #666">{{
              route.query.type == 1005 ? '关于我们' : '详情'
            }}</NBreadcrumbItem>
          </NBreadcrumb>
        </div>
        <div class="online_right_title_line" style="max-width: 1438px"> </div>
        <NEmpty v-if="newsDetails.id == '-1'" class="my-10" description="暂无数据" />

        <template v-else>
          <div v-if="route.query.type != 1005">
            <div class="newedit_title">
              {{ newsDetails.title }}
            </div>
            <div style="" class="newedit_describe">
              <span style="margin: 0 8px">{{ newsDetails.releaseDate }}</span>
              <span style="margin: 0 8px" v-if="newsDetails.contentSource"
                >来源：{{ newsDetails.contentSource }}</span
              >
              <span style="margin: 0 8px">观看次数：{{ newsDetails.viewNum }}</span>
            </div>
          </div>
          <div
            v-if="route.query.type != 1005"
            class="online_right_title_line"
            style="max-width: 1433px; height: 2px; background: #aca9a9"
          >
          </div>
          <div style="min-height: 20px"> </div>
          <div
            v-html="newsDetails.content"
            class="newsDetailscontent"
            style="
              max-width: 1317px;
              margin: 0 auto;
              font-size: 20px;
              text-indent: 40px;
              line-height: 30px;
              letter-spacing: 1px;
            "
          >
          </div>
        </template>
        <div
          v-if="newsDetails.attachments && newsDetails.attachments.length"
          style="padding-left: 100px; margin-top: 40px"
        >
          <div>附件:</div>
          <div v-for="item in newsDetails.attachments" :key="item.id">
            <a
              class="liss"
              target="_blank"
              :href="`https://qingjuck.oss-cn-shanghai.aliyuncs.com/${item.attachmentUrl}`"
              >{{ item.name }}</a
            >
          </div>
        </div>
        <div style="min-height: 20px"> </div>
      </div>
    </div>
    <div class="app-container online_left_news_box app-container_warp" v-else>
      <div class="flex news_box">
        <div class="online_left">
          <div class="online_left_title"> 文章分类 </div>
          <div class="online_left_title_line"> </div>
          <el-menu
            :unique-opened="true"
            style="border: none"
            :default-active="defaultActive"
            class="el-menu-vertical-demo online_left_el-menu"
          >
            <template v-for="item in channelList" :key="item.id">
              <el-sub-menu :index="item.id + ''" v-if="item.children">
                <template #title>
                  <span>{{ item.name }}</span>
                </template>
                <el-menu-item-group>
                  <template #title> </template>
                  <el-menu-item
                    v-for="itemi in item.children"
                    @click="handleClickLevel(itemi, item)"
                    :key="itemi.id"
                    :index="`${itemi.id}`"
                    >{{ itemi.name }}
                  </el-menu-item>
                </el-menu-item-group>
              </el-sub-menu>
              <el-menu-item @click="handleClickLevel(item)" v-else :index="item.id + ''">
                <span>{{ item.name }} </span>
              </el-menu-item>
            </template>
          </el-menu>

          <!-- <div class=" online_left_nav" v-for="(item,index) in channelList" :key="index">
            <div class="flex cu" style="width:100%" @click="handleClickLevel(item)">
              <div class="online_left_nav_logo">
                <el-image v-if="item.channelIcon"
                  :src='`https://qingjuck.oss-cn-shanghai.aliyuncs.com/${item.channelIcon}`'>
                </el-image>
              </div>
              <div class="online_left_nav_text_box" :class="(item.id ==channelItem.id||item.id==pant.id)?'active':''">
                <div>{{item.name}}
                  <el-icon class="roat" :class="(item.id ==openid)?'active':''" v-if="item.children">
                    <ArrowDown />
                  </el-icon>
                </div>

              </div>
            </div>
            <template v-if="item.children&&item.id==openid">
              <div style="height:10px"></div>
              <div v-for="itemi in item.children" @click="handleClickLevel(itemi,item)" class="children"
                :class="(itemi.id == channelItem.id)?'active':''" :key='itemi.id'>
                {{itemi.name}}
              </div>
              <div style="height:10px"></div>
            </template>
          </div> -->
          <div style="height: 130px"> </div>
        </div>
        <div class="online_right">
          <div class="online_right_title flex">
            <span class="mr-1" style="color: #333639; font-size: 18px">所在位置：</span>
            <NBreadcrumb>
              <NBreadcrumbItem style="color: #666" @click="gotoHome">首页</NBreadcrumbItem>
              <NBreadcrumbItem style="color: #666" v-if="channelItem.name">{{
                channelItem.name
              }}</NBreadcrumbItem>
            </NBreadcrumb>
          </div>
          <div class="online_right_title_line"> </div>
          <div>
            <div style="min-height: 500px">
              <div
                class="flex hanglin cu"
                @click="newedit(item, 1)"
                v-for="item in channelNewsList"
                :key="item.id"
              >
                <div style="flex-shrink: 0" class="jvhao flex ambo"><span></span></div>
                <div class="wenzhang_title">
                  {{ item.title }}
                </div>
                <div style="flex-warp: nowarp; flex-shrink: 0" class="tags_box">
                  <div class="tags" v-if="item.topFlag == 1"> 置顶 </div>
                  <div class="tags" v-if="item.freshFlag == 1"> NEW </div>
                </div>
                <div style="flex: 1"></div>

                <div class="new_time" v-if="item.releaseDate">[{{ item.releaseDate }}]</div>
              </div>
            </div>

            <div
              v-if="channelNewsList.length"
              class="flex justify-center"
              style="margin-bottom: 70px; margin-top: 90px"
            >
              <NPagination
                class="mx-auto"
                show-quick-jumper
                v-model:page="page"
                :item-count="pagTotal"
                v-model:page-size="pageSizem"
              >
                <template #prefix> 共 {{ pagTotal }} 条</template>
              </NPagination>
            </div>
            <NEmpty v-if="!channelNewsList.length" class="my-10" description="暂无数据" />
          </div>
        </div>
      </div>
    </div>

    <div class="app-container" v-if="0" style="display: flex; margin-top: 40px">
      <div class="he">
        <ul class="list_ej2 mt20">
          <li class="lis" @click="inlis(item)" v-for="item in newList" :key="item.id">
            <a :style="active == item.id ? 'color: #409eff;' : ''" href="javascript:void(0);"
              >{{ item.title }}
            </a>
          </li>
          <!-- <li>
            列表样式的使用
          </li>
          <li>
            列表样式的使用
          </li> -->
        </ul>
      </div>
      <div class="he" style="flex: 1; padding-top: 30px">
        <div v-html="htmltext"> </div>
      </div>
    </div>
  </Layout>
</template>

<script setup>
import Layout from '@/components/Layout';
import {
  computed,
  ref,
  shallowReactive,
  shallowRef,
  onMounted,
  onBeforeUpdate,
  reactive,
  watch,
  nextTick,
  getCurrentInstance,
} from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { pageByCategory, newsDetail, channelNews, siteChannel, channelSingleNew } from '@/api';
const pageSizem = ref(12);
const page = ref(1);
const pagTotal = ref(0);
const router = useRouter();
const defaultActive = ref('');
watch(page, () => {
  newList.value = [];
  // console.log(classList.value.length);
  getchannelNews(channelItem.value);
});
const route = useRoute();
const active = ref('');
const htmltext = ref('');
const newList = ref([]);
watch(
  () => route.query,
  (val, preVal) => {
    //val为修改后的值,preVal为修改前的值
    console.log('message', val, preVal);
    defaultActive.value = '';
    console.log(defaultActive.value, 'defaultActive666');
    if (val.id) {
      channelNews({ channelId: val.id, current: 1, size: 10 }).then(res => {
        active.value = '';
        htmltext.value = '';
        newList.value = res.data.records;
      });
    }
    if (val.type && !val.id) {
      if (val.type == 1005) {
        newsDetails.value.id = '-1';
        channelSingleNew({ site: 2, topChannel: 1005 }).then(res => {
          console.log(res);
          newsDetails.value = res.data;
          if (!newsDetails.value.id) {
            newsDetails.value.id = '-1';
          }
        });
        return;
      }
      // topChannel
      if (channelList.value) {
        newsDetails.value = {};
        channelList.value.forEach(element => {
          if (route.query.type) {
            if (element.topChannel == route.query.type) {
              if (element.children) {
                handleClickLevel(element.children[0], element, 1);
              } else {
                // channelItem.value = element
                handleClickLevel(element, '', 1);
              }
            }
          }
        });
      }
    }
  },
);
const newsDetails = ref({});
if (route.query.type == 1005) {
  newsDetails.value.id = '-1';

  channelSingleNew({ site: 2, topChannel: 1005 }).then(res => {
    newsDetails.value = res.data;
    if (!newsDetails.value.id) {
      newsDetails.value.id = '-1';
    }
  });
}

if (route.query.newid) {
  newsDetails.value.id = route.query.newid;

  newedit({ id: route.query.newid });
}
if (route.query.id) {
  getchannelNews({ id: route.query.id });
  // channelNews({ channelId: route.query.id, current: 1, size: 20 }).then(res => {

  //   newList.value = res.data.records
  // })
}
const channelList = ref([]);
siteChannel({ site: 2, category: 1 }).then(res => {
  res.data.forEach(element => {
    if (route.query.id) {
      if (element.children) {
        element.children.forEach(item => {
          if (item.id == route.query.id) {
            // pant.value = element
            // channelItem.value = item
            handleClickLevel(item, element);
          }
        });
      } else if (element.id == route.query.id) {
        console.log(element, 666);
        channelItem.value = element;
      }
    } else if (route.query.type) {
      if (element.topChannel == route.query.type) {
        if (element.children) {
          handleClickLevel(element.children[0], element, 1);
        } else {
          // channelItem.value = element
          handleClickLevel(element, '', 1);
        }
      }
    }
  });
  channelList.value = res.data;
});
function getchannelNews(item) {
  channelNews({ channelId: item.id, current: page.value, size: pageSizem.value }).then(res => {
    channelNewsList.value = res.data.records;
    pagTotal.value = res.data.total;
    console.log(defaultActive.value, 'defaultActive');
    defaultActive.value = item.id + '';
  });
}
const channelItem = ref({});
function newedit(item, type) {
  if (type) {
    router.push('/news?id=' + channelItem.value.id + '&newid=' + item.id);
  }
  newsDetail({ id: item.id }).then(res => {
    newsDetails.value = res.data;
  });
}

function inlis(item) {
  active.value = item.id;
  htmltext.value = item.content;
}
const channelNewsList = ref([]);

const pant = ref({});
const openid = ref('');
function gotoHome() {
  router.push('/');
}
function handleClickLevel(item, pants, type) {
  console.log(item);

  if (pants == 1) {
    if (!type) {
      router.push('/news?id=' + item.id);
    }

    newsDetails.value = {};

    return;
  }
  if (!item.children || pants) {
    console.log(1);
    channelItem.value = item;
    page.value = 1;
    getchannelNews(item);
    // channelNews({ channelId: item.id }).then(res => {
    //   channelNewsList.value = res.data.records
    // })
    if (pants) {
      if (!type) {
        router.push('/news?id=' + item.id);
      }

      pant.value = pants;
      openid.value = pants.id;
    } else {
      if (!type) {
        router.push('/news?id=' + item.id);
      }
      pant.value = {};
      openid.value = '';
    }
  }
  if (item.children && !pants) {
    if (openid.value != item.id) {
      openid.value = item.id;
    } else {
      openid.value = '';
    }
  }
}
</script>

<style scoped>
:deep(.n-breadcrumb-item) {
  font-size: 18px;
}

:deep(.n-tag) {
  color: #5e5d5d;
  font-size: 18px;
}
.hanglin {
  align-items: center;
  padding: 0 60px 0 0px;
  font-size: 18px;
  height: 45px;
  color: #4a4a4a;
}
.hanglin:hover .new_time {
  color: #409eff;
}
.hanglin:hover {
  color: #409eff;
}
.ambo {
  justify-content: center;
  align-items: center;
}
.jvhao {
  font-size: 1px;
  height: 7px;
  width: 7px;
  border: 1px solid #fe0000;
  background-color: #fe0000;
  border-radius: 50%;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  -webkit-text-stroke: 1px #fe0000;
  margin: 0 16px 0 47px;
}
.jvhao span {
  width: 1px;
  background-color: #fe0000;
  height: 1px;
}
.new_time {
  color: #878787;
  margin-left: 20px;
  flex-shrink: 0;
}
.wenzhang_title {
  /* flex: 1; */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  max-width: 800px;
  -webkit-line-clamp: 1;
  letter-spacing: 1px;
  -webkit-box-orient: vertical;
}
.tags {
  background-color: rgb(255, 4, 4);
  /* width: 60px; */
  padding: 0px 4px;
  font-size: 12px;
  border-radius: 3px;
  margin-left: 20px;
  display: inline-block;
  color: #fff;
  text-align: center;
}
.lis {
  display: block;
  height: 40px;
  color: #444;
  line-height: 40px;
  font-size: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 400;
}
.lis:hover {
  color: #409eff;
}
.liss {
  line-height: 20px;
  color: #409eff;
}
.list_ej2 {
  width: 300px;
  /* border-right: 1px solid rgb(66, 62, 62); */
  margin-right: 10px;
  height: 600px;
}
.he {
  height: 600px;
  overflow: auto;
}
.tags_box {
  flex-wrap: nowrap;
  flex-shrink: 0 !important;
}
.online_left {
  z-index: 1;
  width: 256px;
  background: #ffffff;
  border-radius: 6px 0 0 6px;
  /* margin-right: 29px; */
  /* height: 749px; */
  box-shadow: 15px -8px 44px 1px rgb(133 133 133 / 19%);
}
.online_left_title {
  height: 79px;
  box-sizing: border-box;
  font-size: 26px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  text-align: center;
  /* padding-top: 30px; */
  line-height: 79px;
}
.online_left_title_line {
  width: 300px;
  height: 1px;
  background: #ebebeb;
  margin: 0 auto 10px;
}
.online_left_nav {
  width: 234px;
  margin-left: 66px;
  min-height: 75px;
  font-size: 22px;
  color: #333;
  /* display: flex; */
  align-items: flex-end;
}
.cu {
  cursor: pointer;
}
.online_left_nav_logo {
  width: 55px;
  max-height: 70px;
  align-self: flex-end;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.online_left_nav_text_box {
  text-align: left;
  /* flex: 1; */
  border-bottom: 1px solid #ebebeb;
  align-self: flex-end;
  font-family: Microsoft YaHei;
  padding-left: 33px;
  padding-right: 33px;
  height: 50px;
  line-height: 50px;
  transition: all 1s;
  border-radius: 15px;
  /* margin: 0 auto; */
}

.online_left_nav_text_box.active {
  /* background-color: red; */
  /* background: linear-gradient(0deg, #4e77fc 0%, #3c6fef 51%, #4c6dff 100%); */
  border-radius: 15px;
  color: #66a6ff;
}
.online_left_nav:hover .online_left_nav_text_box {
  /* background-color: red; */
  /* background: linear-gradient(0deg, #4e77fc 0%, #3c6fef 51%, #4c6dff 100%); */
  border-radius: 15px;
  color: #66a6ff;
}
.online_right {
  flex: 1;
  background-color: #fff;
  /* min-height: 800px; */
  border-radius: 0 6px 6px 0;
  color: #666666;
}

.online_left_nav_text_box.active .roat {
  /* background-color: red; */
  /* background: linear-gradient(0deg, #4e77fc 0%, #3c6fef 51%, #4c6dff 100%); */
  color: #66a6ff;
}
.roat {
  transform: rotate(-90deg);
}
.roat.active {
  transform: rotate(0);
}
.online_right_title {
  height: 79px;
  box-sizing: border-box;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  padding-top: 41px;
  padding-left: 40px;
}
.online_right_title_line {
  max-width: 1132px;
  height: 1px;
  background: #ebebeb;
  margin: 0 auto 32px;
}
.online_right_nav {
  padding-left: 40px;
  font-size: 18px;
}
.online_right_nav_left {
  width: 70px;
}
.online_right_nav_right {
  flex-wrap: wrap;
}
.online_right_nav_box {
  line-height: 32px;
  height: 32px;
  padding: 0 11px;
  margin: 4px;
}
.online_right_nav_box.active {
  background-color: #68bcf1;
  border-radius: 30px;
  color: #fff;
}
.online_right_nav_box:hover {
  background-color: #68bcf1;
  border-radius: 30px;
  color: #fff;
}
.children {
  color: #333333;
  padding-left: 55px;
  height: 60px;
  line-height: 60px;
  cursor: pointer;
}
.children.active {
  color: #66a6ff;
}
.children:hover {
  color: #66a6ff;
}
.newedit {
  background-color: #fff;
  border-radius: 6px;
  padding-bottom: 60px;
  overflow: hidden;
}
.newedit_title {
  max-width: 1000px;
  text-align: center;
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  margin: 64px auto 36px;
}
.newedit_describe {
  font-size: 20px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #aca9a9;
  line-height: 20px;
  margin: 0 auto;
  padding-bottom: 45px;
  text-align: center;
}
.online_left_el-menu {
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  /* padding: 0 30px; */
}
</style>
<style >
.n-config-provider {
  background-color: #f4f4f4;
}
.n-pagination-item--active {
  color: #fff !important;
  background-color: #5e79c4 !important;
  border-radius: 50% !important;
  overflow: hidden;
  border: none !important;
}
.n-pagination-item {
  border-radius: 50% !important;
}
.n-breadcrumb-item__link {
  color: #333639 !important;
}
.n-breadcrumb-item__separator {
  color: #333639 !important;
}
.news_box .el-sub-menu__title,
.news_box .el-menu-item {
  /* box-shadow: -16px 10px 22px 0px rgba(133, 133, 133, 0.19); */
  font-size: 22px;
  line-height: 58px;
  height: 58px;
  padding-left: 40px !important;
}
.news_box .el-menu-item-group {
  background: #f2f7ff;
  font-size: 18px;
  padding-bottom: 10px;
}
.news_box .el-menu-item-group .el-menu-item {
  font-size: 18px;
  width: 148px !important;
  height: 29px !important;
  line-height: 29px !important;
  min-width: 0 !important;
  margin: 17px auto;
  padding: 0 !important;
  text-align: center;
}
.online_left_news_box .news_box .el-sub-menu__title {
  padding: 0 30px 0 80px !important;
  padding-left: 73px !important;
  /* padding-right: 44px !important; */
}
.online_left_news_box .news_box .el-menu-item-group .el-menu-item {
  padding-left: 0px !important;
}
.online_left_news_box .news_box .el-sub-menu__icon-arrow {
  right: 60px !important;
}
.online_left_news_box .news_box .el-menu-item {
  padding-left: 73px !important;
  /* min-height: 100px; */
}
</style>
<style >
.newsDetailscontent td,
.newsDetailscontent th {
  border: 1px solid #000;
}
</style>